module.exports = __webpack_public_path__ + "img/logo.b066709d.svg";